.disclaimer {
    margin-top: 10px;
}

.submitButton {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 10px;
}